import React from "react";
import { connect } from "react-redux";
import * as echarts from "echarts";
import { typePieEchart } from "../../Data/Charts";

class ServiceTypePieChart extends React.Component {
  componentDidMount() {
    this.chartPlace();
  }
  componentDidUpdate(prevProps:Readonly<P>, prevState:Readonly<S>, snapshot:SS) {
    if (prevProps.serviceByTypes !== this.props.serviceByTypes) {
      this.chartPlace();
    }
  }
  chartPlace = () => {
    const {serviceByTypes} = this.props
    const pieChartData = serviceByTypes.map(item => ({
      value: item.total,
      name: item.type,
    }));
    const optionPieEchart = typePieEchart(pieChartData);

    var chartDom = document.getElementById("ServiceTypePieChart");
    var myChart = echarts.init(chartDom);
    var option;
    option = optionPieEchart;

    option && myChart.setOption(option);
  };
  render() {
    return (
        <div>
          <div className="header">
            <h2>Pasta Grafik</h2>
          </div>
          <div className="body">
            <div id="ServiceTypePieChart" style={{ height: 300 }}></div>
          </div>
        </div>
    );
  }
}

const mapStateToProps = (state) => ({
  serviceByTypes: state.analyticalReducer.serviceByTypes,
});

export default connect(mapStateToProps, {})(ServiceTypePieChart);
